import type { Messages } from './fa'

const de: Messages = {
  common: {
    loading: 'Wird geladen…',
    back: 'Zurück',
    copy: 'Kopieren',
    copied: 'Kopiert',
    error: 'Fehler',
    retry: 'Erneut',
    play: 'Spielen',
    go: 'Los',
    save: 'Speichern',
    send: 'Senden',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    friend: 'Freund',
    noName: 'ohne Name',
    all: 'Gesamt',
    daily: 'Täglich',
    monthly: 'Monatlich',
    rank: 'Rang',
    league: 'Liga',
    bigMatch: 'Großes Spiel',
    user: 'Nutzer',
    submitting: 'Wird eingereicht…',
    sending: 'Wird gesendet…',
    watchingAd: 'Werbung wird angezeigt…',
    free: 'Kostenlos',
    search: 'Suchen',
    cardMasked: 'Karte: **** **** **** {last4}',
  },
  coins: {
    gold: 'Gold',
    silver: 'Silber',
    bronze: 'Bronze',
    diamond: 'Diamant',
    coin: 'Münze',
  },
  nav: {
    aria: 'Hauptmenü',
    home: 'Start',
    games: 'Spiele',
    football: 'Fußball',
    horse: 'Pferde',
    airdrop: 'Airdrop',
    gift: 'Geschenk',
    profile: 'Profil',
  },
  home: {
    hello: 'Hallo, {name}',
    luckyTitle: 'Glückszahlen',
    luckySub: '4 Stufen · Bronze bis Diamant · 20 Min.',
    quickStart: 'Schnellstart',
    allGames: 'Alle Spiele ‹',
    tiles: {
      airdrop: { title: 'Täglicher Airdrop', subtitle: 'Tägliche Belohnung' },
      guess: { title: 'Zahl raten', subtitle: '7 Ziffern · ohne 4' },
      football: { title: 'Fußball', subtitle: 'Liga & großes Spiel' },
      horse: { title: 'Pferde-Umfrage', subtitle: 'Rennen & Tipps' },
      gift: { title: 'Geschenkkarte', subtitle: 'Code holen' },
      wallet: { title: 'Wallet', subtitle: 'Münzstände' },
      cash: { title: 'Auszahlen', subtitle: 'Preise abheben' },
      profile: { title: 'Profil', subtitle: 'Level & Einladungen' },
      support: { title: 'Support', subtitle: 'Chat mit dem Team' },
    },
    social: {
      sectionAria: 'Unsere Kanäle',
      title: 'Unsere Kanäle',
      instagram: 'Instagram',
      telegram: 'Telegram',
      twitter: 'Twitter',
      youtube: 'YouTube',
      tiktok: 'TikTok',
    },
  },
  games: {
    title: 'Spiele',
    subtitle: 'Wähle eines und starte',
    status: 'Status',
    chances: 'Chancen',
    of10: '{n} von 10',
    todayNumber: 'Heutige Zahl',
    revealed: 'Zahl veröffentlicht',
    active: 'Spiel aktiv',
    waiting: 'Warte auf Zahl',
    cards: {
      guess: {
        title: 'Zahl raten',
        subtitle: '7-stellige Zahl ohne 4',
      },
      lucky: {
        title: 'Glückszahlen',
        subtitle: '4 Stufen · Bronze bis Diamant · 20 Min.',
        blurb: 'Zahlen wählen. Keine Chancen mehr? Werbung ansehen.',
      },
      morse: {
        title: 'Morsecode',
        subtitle: 'Morse-Taste · Goldmünze',
        blurb: 'Wort per Morse bauen. Richtig: Gold; Werber: Silber.',
      },
      horse: {
        title: 'Pferde-Umfrage',
        subtitle: 'Liga · 3-aus-4 · Zwillinge',
        blurb: 'Rennergebnisse mit Bronze tippen – Gold/Diamant gewinnen.',
      },
    },
  },
  wallet: {
    title: 'Wallet',
    subtitle: 'Kontostände und Auszahlung',
    approxValue: 'Wert in Euro',
    cashTitle: 'Münzen auszahlen',
    cashHint: 'Zur Auszahlung beim Admin oder Transfer an Nutzer: Auszahlen öffnen.',
    goCashOut: 'Zur Auszahlung',
    convertTitle: 'Münzen tauschen',
    convertHint: 'Der Admin setzt den Euro-Preis jeder Münze. Du erhältst nur ganze Zielmünzen; der Rest bleibt bei der Ausgangsmünze.',
    convertFrom: 'Von',
    convertTo: 'Nach',
    convertAmount: 'Menge',
    convertBalance: 'Bestand: {n}',
    convertValue: 'Wert von {amount} {coin}: {eur}',
    convertResult: 'Du bekommst {receive} {to} · {leftover} {from} bleiben',
    convertTooSmall: 'Mindestens {min} {from} für eine {to}',
    convertSame: 'Ausgang und Ziel müssen verschieden sein',
    convertSubmit: 'Tauschen',
    convertOk: '{spent} {from} wurden {receive} {to}',
    convertNeedFunds: 'Nicht genug Münzen',
    eachRate: 'Pro Münze {eur}',
  },
  cashOut: {
    title: 'Auszahlen',
    subtitle: 'Münzen transferieren oder per Admin abheben',
    unlock: 'Mit PIN öffnen',
    setPin: 'PIN setzen',
    enterPin: 'PIN eingeben',
    pinHint: '4–8-stellige PIN',
    toAdmin: 'An Admin',
    toUser: 'An Nutzer',
    amount: 'Betrag',
    coinType: 'Münzart',
    walletAddress: 'Wallet-Adresse',
    recipient: 'Empfänger-ID',
    submit: 'Anfrage senden',
    transfer: 'Transfer',
    history: 'Verlauf',
    statusCompleted: 'Abgeschlossen',
    statusPending: 'Ausstehend',
    statusApproved: 'Admin bestätigt',
    statusRejected: 'Abgelehnt',
    pinSetOk: 'PIN erfolgreich gesetzt',
    pinUnlockOk: 'Auszahlung freigeschaltet',
    pinWrong: 'Falsche PIN',
    pinSetErr: 'PIN konnte nicht gesetzt werden',
    transferOk: 'Transfer erfolgreich',
    transferErr: 'Transfer fehlgeschlagen',
    adminOk: 'Auszahlungsanfrage gesendet',
    adminErr: 'Anfrage fehlgeschlagen',
    errPinLength: 'Die PIN muss 4 bis 6 Ziffern haben',
    errUnlockFirst: 'Öffne die Auszahlung zuerst mit deiner PIN',
    errAmount: 'Münzbetrag eingeben',
    errInsufficient: 'Guthaben reicht nicht',
    errRecipient: 'Empfänger-ID oder Benutzername eingeben',
    errWallet: 'Wallet-Adresse eingeben',
    intro:
      'Zahle hier Münzen aus Spielen und Preisen aus oder sende sie an einen anderen Nutzer.',
    sectionTitle: 'Auszahlung öffnen',
    pinSetupHint: 'Lege zuerst eine PIN für diesen Bereich fest',
    unlockedHint: 'Die Auszahlung ist offen',
    pinEnterHint: 'Gib deine PIN ein, um fortzufahren',
    unlockPinBtn: 'Mit PIN öffnen',
    lock: 'Sperren',
    lockedBanner: 'Die Auszahlung ist gesperrt. Setze oder gib zuerst die PIN ein.',
    tabAdmin: 'Transfer an Admin',
    tabUser: 'Transfer an Nutzer',
    walletPlaceholder: 'Wallet-Adresse des Empfängers',
    recipientLabel: 'Empfänger-ID oder Benutzername',
    recipientPlaceholder: 'z. B. 84729103 oder @username',
    amountLabel: 'Münzbetrag',
    amountPlaceholder: 'Betrag',
    submitAdmin: 'Auszahlung beim Admin einreichen',
    submitUser: 'An Nutzer transferieren',
    historyTitle: 'Auszahlungsverlauf',
    historyEmpty: 'Noch keine Anfrage',
    historyToUser: 'An Nutzer {id}',
    historyToAdmin: 'An Admin',
    modalSetTitle: 'PIN für die Auszahlung setzen',
    modalUnlockTitle: 'Auszahlung öffnen',
    modalSetBody:
      'Wähle eine 4- bis 6-stellige PIN, damit nur du diesen Bereich öffnen kannst.',
    modalUnlockBody: 'PIN der Auszahlung eingeben',
    pinPlaceholder: '4–6-stellige PIN',
    modalSetSubmit: 'Setzen und öffnen',
    modalUnlockSubmit: 'Öffnen',
  },
  profile: {
    language: 'Sprache',
    languageHint: 'App-Sprache wählen',
    invites: 'Einladungen',
    level: 'Level',
    bestCoin: 'Beste Münze',
    idLabel: 'ID',
    idCopyTitle: 'ID für Münztransfer kopieren',
    achievements: 'Erfolge',
    badgeFirst: 'Erste Münze',
    badgeInvite: '5 erfolgreiche Einladungen',
    badgeLucky: 'Glücksstufe 3',
    luckyProgress: 'Fortschritt · Glückszahlen',
    footballScore: 'Fußballpunkte',
    footballScoreHint: 'Gesamtpunkte werden nie zurückgesetzt.',
    noLeagueYet: 'Noch keine Liga oder großes Spiel',
    footballPrizes: 'Fußballpreise',
    inviteFriends: 'Freunde einladen',
    inviteHint: 'Code oder QR teilen — Bronze pro Anmeldung.',
    qrLabel: 'QR-Code Einladungslink',
    qrHint: 'Scannen zum Öffnen des Links',
    copyInviteLink: 'Einladungslink kopieren',
    linkCopied: 'Link kopiert',
    topUsers: 'Top-Nutzer',
    topUsersHint: 'Bestenlisten: Fußball, Pferde, Airdrop, Einladungen',
    viewTopUsers: 'Top-Nutzer anzeigen',
  },
  register: {
    subtitle: 'Einladungscode eingeben zum Start',
    pendingTeam: 'Nach der Anmeldung öffnet sich das Dream-Team',
    noCodeTitle: 'Kein Referral-Code?',
    noCodeHint: 'Wenn du keinen Referral-Code hast, gib unten @sisil_org ein.',
    referralLabel: 'Referral-Code',
    referralPlaceholder: '@sisil_org',
    getRandomCode: 'Zufälligen Code holen',
    submit: 'Registrieren & starten',
    submitting: 'Registrierung…',
    foot: 'Code von Freunden nutzen — sonst @sisil_org eingeben.',
    needTelegram: 'Bitte über den Telegram-Bot öffnen',
    noTgData: 'Telegram-Daten fehlen. Bitte über den Bot starten.',
    registerFail: 'Registrierung fehlgeschlagen. Bitte erneut versuchen.',
    registerErr: 'Registrierungsfehler.',
    codeFetchErr: 'Code konnte nicht geladen werden',
  },
  support: {
    title: 'Support',
    meta: 'Direktchat · Nachrichten nach 7 Tagen gelöscht',
    empty: 'Hallo! Schreib deine Frage hier.',
    placeholder: 'Nachricht schreiben…',
    sendErr: 'Senden fehlgeschlagen',
  },
  airdrop: {
    title: 'Airdrop',
    subtitle: 'Tägliche Präsenz und Belohnung',
    wallet: 'Wallet',
    leadersToday: 'Heutige Besten',
    leadersMonth: 'Monatsbesten',
    usefulTime: 'Nützliche Zeit',
    play: 'Spielen',
    cooldown: 'Pause',
    watchAd: 'Werbung ansehen',
    claim: 'Belohnung holen',
    toastUsefulCharged: '5 Minuten nützliche Zeit aufgeladen',
    scoreToday: 'Heutige Punkte',
    waitNextTurn: 'Warte auf den nächsten Zug',
    usefulTimerActive: '5 nützliche Minuten (nur solange du auf der Seite bist)',
    closedHours: 'Geschlossen von 23:00 bis 00:00',
    berlinTime: 'Deutsche Zeit',
    tapAriaActive: 'Tippen für Punkte',
    tapAriaLocked: 'Airdrop inaktiv',
    glassClosed: 'Geschlossen',
    glassCooldown: 'Zug vorbei',
    glassClosedDetail: '23:00–00:00 · deutsche Zeit',
    glassCooldownDetail: '{time} warten oder Werbung ansehen',
    watchAdInstant: 'Werbung ansehen · sofort 5 Minuten aufladen',
    hintRegistering: 'Wird eingereicht…',
    hintConnecting: 'Verbindung…',
    hintTimerRunning: 'Timer läuft · jeder Tipp +1',
    hintTimerPaused: 'Timer pausiert · kehre zur Seite zurück',
    hintNightlyClosed: 'Diese Stunde ist jede Nacht für alle geschlossen',
    hintCooldownOrAd: '5 Minuten warten oder sofort per Werbung aufladen',
    leadersTablistAria: 'Bestenliste',
    emptyNoScores: 'Noch keine Punkte',
    emptyNoData: 'Keine Daten gefunden',
  },
  football: {
    title: 'Fußball',
    subtitle: 'Tägliche Liga oder großes Spiel wählen',
    modeLeague: 'Tagesliga',
    modeBig: 'Großes Spiel',
    dailyLeague: 'Tagesliga',
    hintLeague:
      'Tägliche Spiele: Sieg / Unentschieden / Niederlage für jedes Spiel wählen (1–3 Tipps) und gemeinsam absenden — 1 Treffer=8, 2 Tipps mit Treffer=4, alle drei=2. Tages-#1 Gold (Werber Silber); Monats-Top 5 Gold.',
    hintBig:
      'Wöchentliche Spiele: Ergebnis tippen und Dream-Team bauen; 5 richtige Tipper werden verlost und das beste Dream-Team gewinnt eine Münze.',
    tabMatches: 'Spiele',
    tabLeaderboard: 'Rangliste',
    tabDreamTeams: 'Dream-Teams',
    tabWinnings: 'Meine Preise',
    totalScore: 'Gesamtpunkte',
    dayScore: 'Tag',
    monthScore: 'Monat',
    noScore: 'Noch keine Punkte',
    noWinnings: 'Noch keine Preise',
    goldCoin: 'Goldmünze',
    silverCoin: 'Silbermünze',
    submitPredictions: 'Video ansehen & Tipps senden',
    submitting: 'Video / Senden läuft…',
    pickRequired: 'Mindestens eine Wahl pro Spiel',
    loadingMatches: 'Spiele werden geladen…',
    noBigMatch: 'Kein großes Spiel definiert',
    noLeagueMatch: 'Kein Ligaspiel definiert',
    noActiveLeague: 'Keine aktive Liga',
    readyBatch: 'Zum Absenden von {n} Spielen Video ansehen',
    draftHint: 'Für {n} offene Spiele tippen, dann gemeinsam absenden',
    topOf: 'Top von {mode}',
    wonPrizes: 'Gewonnene Preise',
    dayMonth: 'Tag {day} · Monat {month}',
    outcomeHome: 'Sieg',
    outcomeAway: 'Niederlage',
    outcomeDraw: 'Unentschieden',
    dayGoalsTitle: 'Tages-Torsummen tippen',
    dayGoalsHint:
      'Tippe die Summe der Heim- und Auswärtstore über {n} Spiele heute. Beide richtig → {silver} Silber (kein Referral). Kosten: 1 Bronze oder ein Video.',
    dayGoalsHome: 'Summe Heimtore',
    dayGoalsAway: 'Summe Auswärtstore',
    dayGoalsPayBronze: 'Mit {n} Bronze senden',
    dayGoalsPayAd: 'Video ansehen',
    dayGoalsSubmitAfterAd: 'Tipp senden',
    dayGoalsAdReadyHint: 'Video gesehen — jetzt Tipp senden',
    dayGoalsSubmitted: 'Tipp gespeichert: Heim {home} · Auswärts {away}',
    dayGoalsInvalid: 'Tore müssen ganze Zahlen ≥ 0 sein',
    dayGoalsErr: 'Tor-Tipp konnte nicht gesendet werden',
    draws: {
      daily_correct: 'Tägliche Liga-Verlosung',
      weekly_correct: 'Wöchentliche Großspiel-Verlosung',
      daily_top: 'Tages-Topscorer',
      daily_referral: 'Referral-Bonus Tagesgewinner',
      monthly_top: 'Monats-Topspieler',
      best_dream_team: 'Bestes Dream-Team',
      weekly_dream_team_raffle: 'Dream-Team-Verlosung',
      league_day_goals: 'Liga-Tages-Torsummen',
    },
    errSubmitPrediction: 'Tipp konnte nicht gesendet werden',
    errSubmitPoll: 'Umfrage konnte nicht gesendet werden',
    statusLive: 'Live',
    statusFinished: 'Beendet',
    statusUpcoming: 'Anstehend',
    yourPoll: 'Deine Umfrage',
    yourPrediction: 'Dein Tipp',
    pickedSuffix: '(bezogen auf {team})',
    pickHint: 'Ergebnis aus Sicht von {team} — Sieg / Unentschieden / Niederlage:',
    pollClosed: 'Die Umfrage für dieses Spiel ist geschlossen',
    predictionClosed: 'Tipps für dieses Spiel sind geschlossen',
    buildDreamTeam: 'Dream-Team bauen',
  },
  horse: {
    title: 'Pferde-Umfrage',
    subtitle: 'Renntipps und Preise',
    modesTitle: 'Modi',
    leaderboard: 'Rangliste',
    myBets: 'Meine Tipps',
    mode: {
      league: {
        label: 'Liga',
        fee: 'Kostenlos',
        hint: '5–15 Rennen hintereinander · 1 Pferd · Punkte 9…1 · Sieger Gold · Monats-Top',
      },
      three_in_four: {
        label: 'Drei aus vier',
        fee: '2 Bronze oder 5 Videos',
        hint: '4 Rennen · je 4 aktive · pro Rennen Reihenfolge 1…4 setzen · Punktesumme · Gold',
      },
      twins: {
        label: 'Zwillinge',
        fee: '2 Bronze oder 5 Videos',
        hint: '5 Rennen · 2 Pferde · 3 richtig Gold / 5 richtig Diamant',
      },
      three_one: {
        label: 'Drei zu eins',
        fee: '2 Bronze oder 5 Videos',
        hint: '5 Rennen · 3 Pferde · 5 erste Plätze → Gold',
      },
      more_chance: {
        label: 'Mehr Chance',
        fee: '1 Bronze oder 3 Videos',
        hint: '5 Rennen · 2 Pferde · beste Platzierung · ≥43 Gold',
      },
    },
    errLoad: 'Laden fehlgeschlagen',
    errGeneric: 'Fehler',
    errWatchAdsFirst: 'Sieh zuerst {n} Videos',
    msgSubmitted: 'Umfrage gesendet',
    errNotSubmitted: 'Nicht gesendet',
    msgAdProgress: 'Video gezählt · {watched} von {required}',
    errAdFailed: 'Werbung nicht gezählt',
    finishPosition: 'Platz {n}',
    entryPrefix: ' · Einsatz: ',
    monthlyTop: 'Monatliche Top-Nutzer',
    yourScore: 'Deine Punkte:',
    todayScore: '(heute {n})',
    emptyNoScores: 'Noch keine Punkte',
    openPollsTitle: 'Offene Umfragen',
    emptyNoPolls: 'Keine Renn-Umfrage',
    roundEntryPaid: 'Einsatz {bronze} Bronze oder {ads} Videos',
    courseCount: ' · {n} Rennen',
    join: 'Mitmachen',
    entrySubmitted: 'Gesendet · Punkte: {score}',
    entryWinner: ' · gewonnen {amount} {type}',
    orderHint: 'Reihenfolge festlegen (1 = weiter vorn)',
    placeAmongHint: 'Reihenfolge dieser 4 aktiven Pferde festlegen: 1., 2., 3., 4.',
    placeOption: 'Platz {n}',
    pickNHorses: ' · {n} Pferde wählen',
    submitPoll: 'Umfrage senden',
    submitWithBronze: 'Mit {n} Bronze senden',
    watchVideos: 'Videos ansehen ({watched} von {required})',
    submitWithVideos: 'Mit Videos senden ({n})',
    roundLeaderboard: 'Rangliste dieser Runde',
    votingClosed: 'Abstimmung geschlossen — Rennen gestartet oder vom Admin geschlossen',
    historyTitle: 'Meine Tipps',
    historyEmpty: 'Du hast noch an keiner Umfrage teilgenommen',
    historyView: 'Ansehen',
    historyYourPicks: 'Deine Tipps',
    historyOfficial: 'Offizielles Ergebnis',
    historyPending: 'Ergebnis steht noch aus',
    historyStatusOpen: 'Läuft',
    historyStatusWaiting: 'Wartet auf das Ergebnis',
    historyStatusSettled: 'Ergebnis da',
    historyScore: 'Punkte {score}',
    historyCorrect: '{n} richtig',
    historyMine: 'Dein Tipp',
    historyPredicted: 'Tipp: Platz {n}',
    historyNoRound: 'Diese Runde ist nicht mehr verfügbar',
    historyOpenPoll: 'Diese Umfrage öffnen',
  },
  gift: {
    title: 'Geschenkkarte',
    subtitle: 'Codes holen und einlösen',
    redeem: 'Code einlösen',
    myCodes: 'Meine Codes',
    statusUsedWithPrize: 'Eingelöst · Preis: {prize}',
    statusUsed: 'Eingelöst',
    statusExpired: 'Abgelaufen',
    statusActiveHint: 'Aktiv — tippen zum Ausfüllen',
    badgeUsed: 'Eingelöst',
    badgeExpired: 'Abgelaufen',
    badgeActive: 'Aktiv',
    errEnterCode: 'Code eingeben',
    errInvalidCode: 'Ungültiger Code',
    noticeAlreadyUsed: 'Dieser Code wurde bereits verwendet.',
    noticeExpired: 'Dieser Code ist abgelaufen und nicht mehr gültig.',
    noticeNotFound: 'Dieser Code wurde nicht gefunden.',
    errPickPrize: 'Wähle einen Preis',
    claimOk: 'Preis gespeichert',
    errClaim: 'Preis konnte nicht gespeichert werden',
    intro:
      'Wenn du den Airdrop gewonnen hast, gib hier den Ein-Stunden-Code ein, sieh die Preise und wähle einen.',
    codeLabel: 'Belohnungscode',
    codePlaceholder: 'z. B. AIRDWARD-...',
    enterPrizes: 'Zu den Preisen',
    activeCodesTitle: 'Aktive Codes ({n})',
    inactiveCodesTitle: 'Eingelöste / abgelaufene Codes ({n})',
    activeCodeLabel: 'Aktiver Code',
    pickTitle: 'Wähle einen Preis',
    claimPrize: 'Preis sichern',
    doneTitle: 'Preis gespeichert',
    doneNote: 'Dieser Code wurde verwendet und ist nicht mehr einlösbar.',
    exit: 'Geschenke verlassen',
  },
  guess: {
    title: 'Zahl raten',
    subtitle: '7 Ziffern ohne 4',
    errSevenDigits: 'Die Zahl muss 7-stellig sein',
    errNoFour:
      'Die Ziffer 4 ist nicht erlaubt — bitte eine Zahl ohne 4 eingeben (erlaubt: 0, 1, 2, 3, 5, 6, 7, 8, 9)',
    errSubmit: 'Tipp konnte nicht gesendet werden',
    statusUnavailable: 'Spielstatus nicht verfügbar',
    revealAt: 'Veröffentlichung um 23:30',
    todayPrompt: 'Welche Zahl ist heute?',
    hint: 'Rate eine 7-stellige Zahl ohne die Ziffer 4. Jede Zahl kannst du nur einmal senden.',
    placeholder: 'z. B. 1235678',
    attemptsLeft: 'Verbleibende Chancen',
    submit: 'Tipp senden',
    revealedTitle: 'Heutige Zahl veröffentlicht',
    bannerWin: 'Glückwunsch! Du hast heute gewonnen',
    bannerLose: 'Heute leider nicht gewonnen',
    winnersCount: 'Heute {n} Gewinner',
    noWinners: 'Heute keine Gewinner',
    waitingNoNumber: 'Heutige Zahl ist noch nicht festgelegt',
    waitingSchedule: 'Erzeugt um 00:01 · Veröffentlichung um 23:30',
    untilReveal: 'Bis zur Veröffentlichung: {countdown}',
    winnersToday: 'Heutige Gewinner',
    userHash: 'Nutzer #{id}',
    correctTag: 'Richtig',
  },
  lucky: {
    title: 'Glückszahlen',
    subtitle: '4 Stufen bis Diamant',
    unlimited: 'Unbegrenzt',
    toastDemotedStageChance: 'Zeit oder Chancen dieser Stufe sind vorbei — zurück zu Stufe 1',
    toastPickExact: 'Du musst genau {n} Zahlen wählen',
    toastDemotedStage: 'Zeit dieser Stufe ist vorbei — zurück zu Stufe 1',
    toastAdCharged: '✅ Chancen aufgeladen',
    chancesLabel: 'Chancen',
    stepsAria: 'Stufen',
    windowClosed: 'Das Spielfenster ist heute geschlossen. Komm morgen wieder.',
    allDoneTitle: 'Alle Stufen für heute geschafft!',
    allDoneHint: 'Morgen hast du wieder neue Chancen.',
    sessionExpiredStage1:
      'Diese Sitzung ist abgelaufen. Die 3 Gratis-Chancen von heute bleiben und füllen sich morgen. Videos bleiben unbegrenzt.',
    sessionExpiredRestart:
      'Zeit dieser Stufe ist vorbei. Beim Neustart gehst du zurück zu Stufe 1.',
    restart: 'Neu starten',
    hintPick: 'Wähle {pick} von {pool} Zahlen',
    hintOneWinner:
      'Nur 1 von {pool} Zahlen ist richtig — hast du sie gewählt, gewinnst du',
    rewardLine: 'Preis: Münze {coin} · gewählt {selected}/{pick}',
    stage1Quota: '3 Gratis-Chancen für den ganzen Tag, morgen wieder voll · jedes Video +5 Chancen',
    stageFreePrefix: 'Gratis in dieser Stufe: {free}',
    noAds: ' · ohne Werbung',
    adsRemaining: ' · Werbung übrig: {n}',
    stageTimeLimit: ' · 20 Minuten Zeit',
    confirmPicks: 'Auswahl bestätigen',
    needAdNoFree: 'Diese Stufe hat keine Gratis-Chancen. Sieh Werbung, um zu tippen.',
    needAdRecharge: 'Keine Chancen mehr. Mit Werbung aufladen.',
    watchAdPlus: 'Werbung ansehen · +{n} Chance',
    loseDemotedTitle: 'Zurück zu Stufe 1',
    loseTitle: 'Verloren!',
    correctWas: 'Die richtige Zahl war',
    loseDemotedHint:
      'Du bist zurück bei Stufe 1. Die Gratis-Chancen von heute bleiben, wie sie sind.',
    loseNumbersChanged: 'Für den nächsten Versuch wurden die Glückszahlen geändert.',
    attemptsLeft: 'Chancen übrig: {n}',
    continueStage1: 'Weiter bei Stufe 1',
    tryAgain: 'Nochmal versuchen',
  },
  morse: {
    title: 'Morsecode',
    subtitle: 'Wort per Morse bauen',
    errEnterWord: 'Wort mit der Morse-Taste eingeben',
    windowClosedTitle: 'Das Spielfenster ist heute geschlossen',
    windowClosedHint: 'Morgen von Mitternacht bis 23:30 deutscher Zeit wieder offen',
    solved: 'Gelöst',
    timeLeft: 'Verbleibende Zeit',
    clock: 'Uhr',
    keyTitle: 'Morse-Taste',
    keyHint: 'Kurz = Punkt · halten = Strich. Nach einer Pause wird der Buchstabe gespeichert.',
    readoutWord: 'Word',
    keyLabel: 'Morse',
    keyHoldHint: 'hold · · —',
    backspace: '⌫ Löschen',
    submitGuess: 'Tipp senden',
    clearAll: 'Alles löschen',
    sessionEnded: 'Die Sitzung dieser Runde ist beendet',
  },
  topUsers: {
    title: 'Top-Nutzer',
    subtitle: 'Bestenlisten aller Bereiche',
    emptyFootball: 'Noch keine Punkte in der Fußballliga',
    emptyHorse: 'Noch keine Punkte in der Pferdeliga',
    emptyAirdrop: 'Noch keine Airdrop-Punkte',
    emptyInvite: 'Noch keine Einladung',
    scoreLabel: 'Punkte',
    inviteLabel: 'Einladung',
  },
  dreamTeam: {
    title: 'Dream-Team',
    titlePlural: 'Dream-Teams',
    brandBoard: 'Dream-Team · Sisil',
    defaultTeamName: 'Mein Dream-Team',
    matchVs: '{home} gegen {away}',
    listSeparator: ', ',
    positions: {
      gk: 'Torwart',
      def: 'Verteidiger',
      mid: 'Mittelfeld',
      fwd: 'Stürmer',
      voteShort: {
        def: 'Abwehr',
        fwd: 'Angriff',
      },
    },
    status: {
      draft: 'Entwurf',
      submitted: 'Gesendet',
      submittedSpaced: 'Gesendet',
      notSubmitted: 'Nicht gesendet',
      teamSubmittedCheck: 'Team gesendet ✓',
      teamSubmittedHeading: '✅ Dream-Team gesendet',
    },
    explore: {
      ariaSearch: 'Suche',
      searchPlaceholder: 'Suchen…',
      empty: 'Leer',
      notFound: 'Nicht gefunden',
      exploreTeams: '🔍 Teams entdecken',
    },
    view: {
      notFound: 'Dieses Dream-Team wurde nicht gefunden',
      backToExplore: 'Zurück zur Übersicht',
      labelTeamName: 'Name des Dream-Teams',
      labelFormation: 'Aufstellung',
      metaRating: '★ {avg} ({votes}) · {totalScore} Punkte',
      creator: 'Ersteller: {name}',
      buildMyTeam: 'Mein Team bauen',
      pitchAlt: 'Animation des Dream-Team-Spielfelds',
    },
    builderPage: {
      matchNotFound: 'Spiel nicht gefunden',
      backToFootball: 'Zurück zu Fußball',
    },
    builder: {
      toastEnterName: 'Namen des Dream-Teams eingeben',
      toastPlayersRemaining: 'Noch {remaining} Spieler offen ({selected} von {total})',
      toastSaveError: 'Dream-Team konnte nicht gespeichert werden',
      toastUpdated: 'Dream-Team aktualisiert',
      toastCreated: 'Dream-Team erstellt',
      toastSubmitted: 'Dream-Team gesendet',
      toastSubmitError: 'Dream-Team konnte nicht gesendet werden',
      toastAnimationFailed: 'Animation konnte nicht erstellt werden',
      toastLinkCopied: 'Team-Link kopiert',
      toastFileNotReady: 'Datei ist noch nicht bereit',
      toastWaitForFile: 'Warte, bis die Datei bereit ist…',
      toastVideoSaved:
        'Video gespeichert — nimm dasselbe Video in die Story, damit die Animation läuft',
      toastGifSaved: 'GIF gespeichert — bleibt die Story stehen, nimm das Video',
      toastStoryStepsVideo:
        'Video ist in der Galerie → neue Story → dasselbe Video wählen → Link einfügen',
      toastStoryStepsFile:
        'Datei ist in der Galerie → neue Story → dieselbe Datei wählen → Link einfügen',
      labelTeamName: 'Name des Dream-Teams',
      labelFormation: 'Aufstellung',
      placeholderTeamName: 'z. B. Mein Dream-Team',
      activeCardGroups: 'Aktive Kartengruppen dieses Spiels:',
      noActiveCards:
        'Für dieses Spiel ist keine Karte aktiv. Ein Admin muss im Tab „Fußball“ die Kartengruppen dieses Spiels wählen.',
      pickEmpty: 'Wählen',
      playersSelected: 'Gewählte Spieler: {selected} von {total}',
      filterAll: 'Alle ({count})',
      pickPositionTitle: '{icon} {position} wählen',
      pickSlotHint: 'Wähle ein Feld auf dem Spielfeld',
      cardCount: '{count} Karten',
      tapEmptySlot: 'Tippe auf ein leeres Feld auf dem Spielfeld',
      noCardsForPosition: 'Keine Karte für diese Position in den aktiven Gruppen dieses Spiels',
      searchPlayerPlaceholder: 'Spielername suchen...',
      badgeSelected: 'Ausgewählt',
      badgeInTeam: 'Im Team',
      badgeAdd: '+ Hinzufügen',
      submittedBlurb:
        'Nach dem Senden ist die Aufstellung gesperrt und nimmt an der Verlosung und am Wettbewerb „Bestes Dream-Team“ teil.',
      copyLink: 'Link kopieren',
      shareTeam: '📤 Team teilen',
      submitTeam: 'Team senden',
      saving: 'Wird gespeichert...',
      updateTeam: 'Team aktualisieren',
      buildTeam: 'Team bauen ({selected}/{total})',
      shareModal: {
        title: 'Story mit Spielfeld-Animation',
        buildingComposition: 'Aufstellungs-Animation wird erstellt…',
        fileNotReady: 'Datei ist noch nicht bereit',
        instagramTip:
          'Instagram friert Galerie-GIFs meist ein — nimm ein kurzes Video, damit sich die Karten bewegen.',
        instagramSteps:
          '1) Diese Datei speichern/teilen 2) Story → dasselbe Video/GIF 3) Link mit einem Sticker einfügen.',
        building: 'Animation wird erstellt…',
        shareVideo: '📤 Spielfeld-Video speichern / teilen',
        shareGif: '📤 Spielfeld-GIF speichern / teilen',
        downloadVideo: 'Video herunterladen',
        downloadGif: 'GIF herunterladen',
        copyBotLink: 'Bot-Link kopieren',
      },
    },
    image: {
      stickerHint: 'Link mit einem Link-Sticker in die Story kleben',
      cta: 'Bau dein eigenes Dream-Team und hol Punkte',
      unknownInitial: '?',
    },
    voting: {
      sectionTitle: 'Bewerten (1 bis 5)',
      alreadyVoted: 'Du hast schon abgestimmt',
      yourRating: 'Deine Bewertung: {rating}/5',
      pollClosed: 'Die Umfrage für dieses Spiel ist geschlossen',
      pollClosedHint: 'Abstimmen ist nur vor Spielbeginn möglich',
      ownerHint: 'Das ist dein Team; andere können dafür stimmen.',
      slotLine: '{position} · Platz {slot}',
      toastPollClosed: 'Die Umfrage für dieses Spiel ist geschlossen',
      toastVoteRecorded: 'Deine Stimme wurde gespeichert',
      toastVoteError: 'Stimme konnte nicht gespeichert werden',
      toastCannotVoteOwn: 'Du kannst nicht für dein eigenes Team stimmen',
      votingOpen: 'Abstimmung offen',
      votingClosed: 'Geschlossen',
      yourTeamChip: 'Dein Team',
      topTeamsTitle: 'Beste Teams dieses Spiels',
    },
  },
  fantasy: {
    explore: {
      subtitleRefreshing: 'Wird aktualisiert…',
      subtitleDefault: 'Suchen und abstimmen',
      searchPlaceholder: 'Teamname oder Link suchen',
      resultsFor: 'Ergebnis für „{query}“',
      loadError: 'Teams konnten nicht geladen werden',
      emptySearch: 'Kein Team mit diesem Namen oder Link gefunden',
      emptyDefault: 'Noch kein aktives Team zum Abstimmen',
      backToMatches: 'Zurück zu den Spielen',
    },
    builder: {
      title: 'Dream-Team-Baukasten',
      stepOf: 'Schritt {step} von 2',
      stepTeamName: '📝 Teamname',
      stepFormation: '🧩 Aufstellung',
      stepCardGroups: '📁 Kartengruppen dieses Spiels',
      cardGroupsHint: 'Im nächsten Schritt kannst du nur Karten aus diesen Gruppen wählen.',
      nextStep: 'Weiter: Spieler aufstellen →',
      registeredLineup: '📋 Gespeicherte Aufstellung',
      toastEnterName: 'Teamnamen eingeben',
      toastPickAllSlots: 'Wähle für jeden der {totalSlots} Plätze einen Spieler',
      toastLineupUpdated: 'Aufstellung aktualisiert',
      toastTeamCreated: 'Team erstellt',
      toastSaveError: 'Team konnte nicht gespeichert werden',
      toastSubmittedForPoll: 'Team zur Umfrage gesendet',
      toastSubmitError: 'Team konnte nicht gesendet werden',
      toastLinkCopied: 'Team-Link kopiert',
      toastCopyFailed: 'Link konnte nicht kopiert werden',
      shareVoteText: 'Stimm für mein Dream-Team: {teamName}',
      charCount: '{length}/40',
      pickSlotHint: 'Wähle einen Platz auf dem Spielfeld',
      noCardsForPosition: 'Keine Karte für diese Position in den Gruppen dieses Spiels',
      shareAndPoll: 'Team teilen und Umfrage öffnen',
      copyTeamLink: 'Team-Link kopieren',
      seeOtherTeams: 'Andere Teams ansehen',
      submitForPoll: 'Zur Umfrage senden',
      saveTeam: 'Team speichern ({selected}/{total})',
      saveHint: 'Wähle alle {totalSlots} Spieler, damit Speichern aktiv wird',
    },
    vote: {
      notFound: 'Team nicht gefunden oder der Link ist ungültig',
      back: 'Zurück',
    },
  },
}

export default de
